import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TipoConteudo } from 'src/app/model/arquivo.model';
import { JanelaEnvioProtocolo } from 'src/app/model/protocolo-arquivo.model';



@Component({
    selector: 'app-solicitacao-honra-lote-envio',
    templateUrl: './solicitacao-honra-lote-envio.component.html',
    standalone: false
})
export class SolicitacaoHonraLoteEnvioComponent implements OnInit {

  titulo = 'Envio de solicitações de honra';
  instrucoesEnvio = 'Envie um arquivo com suas solicitações de honra para a janela atual.';
  tipoConteudoArquivo = TipoConteudo.SOLICITACOES_HONRA;
  janelaEnvioAtual: JanelaEnvioProtocolo;
  textoBtnArquivoExemplo = "Exemplo de Solicitação de Honra";
  tipoArquivoExemplo = "Solicitação de Honra";

  constructor(protected injector: Injector,
    //private permissaoService: PermissaoService,
    private activatedRoute: ActivatedRoute,
    //private bnAlertsService: BnAlertsService
    ) {

    this.janelaEnvioAtual = this.activatedRoute.snapshot.data['janelaAtual']//resolver
  }
 
  ngOnInit() {
  
  }
}
